import { Button } from "devextreme-react";
import DataGrid, {
    Column,
    FilterRow,
    Grouping,
    GroupPanel,
    Item,
    KeyboardNavigation,
    Pager,
    Paging,
    SearchPanel,
    Toolbar,
} from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from "../../components/CustomPreparedHeaderCell";
import { allowedPageSizes } from "../../components/GlobalDataGridConfigurations";
import { ROUTE_CREATE_EDIT_POST_EXHIBIT, ROUTE_WELCOME } from "../../routes/Routes";
import { useNavigate } from "react-router-dom";

export default function DataGridPostExhibits({ dataSource, isCostEstimate , gridRef }) {
    const navigate = useNavigate();

    const navigateToEditPostExhibit = (postExhibitId) => {
        navigate(ROUTE_CREATE_EDIT_POST_EXHIBIT.withSlash, {
            state: {
                postExhibitId: postExhibitId,
                isCostEstimate

            }
        });
    }

    return (
        <DataGrid
            ref={gridRef}
            columnAutoWidth={true}
            dataSource={dataSource}
            onCellPrepared={CustomPreparedHeaderCell}
            showBorders={true}
            showRowLines={true}
            rowAlternationEnabled={true}
        >
            <FilterRow visible={true} />
            <KeyboardNavigation enabled={true} />
            <Paging defaultPageSize={10} />
            <Pager
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
            />
            <SearchPanel visible placeholder='Search...' highlightCaseSensitive />
            <GroupPanel visible={dataSource.length > 0} />
            <Grouping autoExpandAll={true} />
            <Column
                dataField="PostExhibitId"
                caption="PostExhibit ID"
                cellRender={(cellData) => (
                    <a
                        href="#"
                        style={{ fontWeight: 'bold', color: '#005288' }}
                        onClick={(e) => {
                            e.preventDefault();
                            navigateToEditPostExhibit(cellData.value)
                        }}
                    >
                        Edit: {cellData.value}
                    </a>
                )}
                sortOrder="desc"
                fixed={true}
                fixedPosition="left"
            />
            <Column
                dataField="Name"
                caption="Name"
                fixed={true}
            />
            <Column
                dataField="Comment"
                caption="Comment"
                cellRender={(cellData) => (
                    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {cellData.value}
                    </div>)
                }
            />
            <Column
                dataField="TaskOrderNumber"
                caption="Task Order Number"
                fixed={true}
            />
            <Column
                dataField="VendorName"
                caption="Vendor"
                fixed={true}
            />
            <Column
                dataField="ContractNumber"
                caption="Contract Number"
                fixed={true}
            />
            <Column dataField="RegionId" caption="Region" />
            <Column dataField="PostExhibitStatus.Name" caption="Status" />
            <Column dataField="StartDate" caption="Start Date" />
            <Column dataField="EndDate" caption="End Date" />
        </DataGrid>
    )
}